import { exchangeOffersAPI } from '@/api/admin/exchangeOffers';

const state = () => ({
  charterResaleOffersList: [],
  spacesOffersList: [],
  jetCardHoursOffersList: [],
  offerBidsList: [],
})

const mutations = {
  setCharterResaleOffersList (state, data) {
    state.charterResaleOffersList = data
  },
  setSpacesOffersList (state, data) {
    state.spacesOffersList = data
  },
  setJetCardHoursOffersList (state, data) {
    state.jetCardHoursOffersList = data
  },
  setOfferBidsList (state, data) {
    state.offerBidsList = data
  },
}

const actions = {
  async getOffersList ({commit}, historical) {
    try {
      const result = await exchangeOffersAPI.getExchangeOffers(historical);
      if (result.data.isSuccessfull) {
        commit('setCharterResaleOffersList', result.data.item.charterReSaleOffers);
        commit('setSpacesOffersList', result.data.item.spacesOffers);
        commit('setJetCardHoursOffersList', result.data.item.jetCardHoursOffers);
      }
    } catch (e) {
      console.log('e', e)
    }
  },
  async getBidsByOfferId ({commit}, bidId) {
    try {
      const result = await exchangeOffersAPI.getBidsByOfferId(bidId);
      if (result.data.isSuccessfull) {
        commit('setOfferBidsList', result.data.item);
      }
    } catch (e) {
      console.log('e', e)
    }
  },
  async deleteOffer ({commit}, offerId) {
    try {
      const result = await exchangeOffersAPI.deleteOfferById(offerId);
      return result.data;
    } catch (e) {
      console.log('e', e)
    }
  },
  async cancelBid ({commit}, bidId) {
    try {
      const result = await exchangeOffersAPI.cancelBidById(bidId);
      return result.data;
    } catch (e) {
      console.log('e', e)
    }
  },
}

export default {
  state,
  mutations,
  actions,
}